import Config from './interceptors.config';
import definition from './http.class';

/**
 * httpInterceptor settings
 * @type {{name: string, definition: HttpInterceptor}}
 */
const HttpInterceptor = {
    name: 'httpInterceptor',
    definition
};

export {
    Config,
    HttpInterceptor
};



// WEBPACK FOOTER //
// ./app/services/interceptors/index.js